// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const IconThumbsUpSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      viewBox="0 0 60 58"
      xmlns="http://www.w3.org/2000/svg"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.456 14.181l2.83 1.697a3.626 3.626 0 011.151 5.12L33.52 25.37h9.187a3.628 3.628 0 013.627 3.625v7.515c0 .563-.13 1.118-.382 1.622l-1.681 3.36a3.626 3.626 0 01-3.247 2.003H24.571V26.004l7.885-11.823zm.552 2.443l-6.623 9.93v15.13h14.64a1.814 1.814 0 001.622-1.002l1.68-3.36a1.81 1.81 0 00.193-.811v-7.515a1.812 1.812 0 00-1.814-1.812H30.132l4.796-7.192a1.812 1.812 0 00-.575-2.56l-1.345-.808zM13.69 25.371h7.254v18.125H13.69V25.371zm1.814 1.813v14.5h3.627v-14.5h-3.627z"
      />
    </svg>
  )
}
